exports.APIS = {
  Auth: "/common/auth/admin-login",
  UserInfo: "/common/auth/user-info",
  AdminInfo: "/common/auth/admin-login",
  ContactUS: "/contact-us",

  dashboard: {
    dashboard: "/admin/dashboard",
  },
  gymMember: {
    register: "signup"
  },

  gymOwner: {
    register: "/gym-owner/register",
    step1: "/gym-owner/register/step1",
    step2: "/gym-owner/register/step2",
    step3: "/gym-owner/register/step3",
    step4: "/gym-owner/register/step4",
    step5: "/gym-owner/register/step5",
    step6: "/gym-owner/register/step6",
    step7: "/gym-owner/register/step7",
    getProgress: "/get-step-detail",
    amenities: "/amenities",
    facilities: "/facilities",
    keyServices: "/key-services",
    businessConstitution: "/business-constitution",
    businessDesignation: "/business-designation",
    appSetup: "/app-setup",
    aboutUs: "/about-us",
    states: "/states",
    cities: "/cities",
    goals: "/goalsmaster",
    levels: "/levelsmaster",
    privacyPolicy: "/privacy-Policy",
    termsCondition: "/terms-condition",
    socialLink: "/social_links",

  },
};